import { cloneDeepWith, forIn, isPlainObject } from 'lodash';
import { format } from 'date-fns';
import { isOfTypeDate, isOfTypeFunction } from '@/utils/guards';

export const prepareForRequest = (obj: Record<string | number, unknown>) => {
    const copy = cloneDeepWith(obj);

    forIn(copy, (value, key) => {
        if (isOfTypeDate(value)) {
            copy[key] = format(value, 'yyyy-MM-dd'); //  iso string without time zone
        }

        if (isOfTypeFunction(value)) {
            delete copy[key];
        }

        if (isPlainObject(value)) {
            copy[key] = prepareForRequest(
                value as Record<string | number, unknown>
            );
        }
    });

    return copy;
};
